'use client';

// Providers
import { useAuthActions } from '@/providers/auth';

// Store
import { appStoreActions, useIsShouldForceLogout, useMessage } from '@/stores';
import { useFirebase } from '@/providers/firebase';

// Components
import { ForceLogoutDialog } from '../ForceLogoutDialog';

// Hooks
import { useWebSocketMessage } from '@/hooks/useWebSocket';

// Types
import { UserProfile } from '@/types';
import { ActivityType } from '@shared/types';
import { WebSocketMessage } from '@/services/websocket';

// Constants
import { AUTH_ERROR_MESSAGES } from '@/constants/auth';
import { UserStatus } from '@shared/constants';

/**
 * Component that monitors user session and handles force logout dialog
 * This component manages both session monitoring and force logout dialog state
 */
export const SessionMonitor = () => {
  const {
    user
  } = useFirebase();
  const {
    handleSignOut
  } = useAuthActions();
  const shouldForceLogout = useIsShouldForceLogout();
  const message = useMessage();

  // Handle WebSocket messages for user deactivation
  useWebSocketMessage((message?: WebSocketMessage) => {
    if (!message || !user?.email) return;

    // Check for USER_DEACTIVATE message
    if (message.channel === ActivityType.USER_DEACTIVATE) {
      const updatedUser = message.payload as UserProfile;

      // Check if the updated user is the current user and has inactive status
      if (user.email === updatedUser.email && updatedUser.status === UserStatus.INACTIVE) {
        appStoreActions.setForceLogoutWithMessage(AUTH_ERROR_MESSAGES.ACCOUNT_DEACTIVATED);
      }
    }
  }, [user?.email]);
  const handleCloseDialog = async () => {
    await handleSignOut();
  };
  return <ForceLogoutDialog open={shouldForceLogout} message={message} onClose={handleCloseDialog} data-sentry-element="ForceLogoutDialog" data-sentry-component="SessionMonitor" data-sentry-source-file="index.tsx" />;
};